<vc-badge
    [label]="'CORE.ASSESSMENT_STATUS.' + status | transloco"
    [status]="statusClrMap.get(status) ?? 'info'"
    [prefixIcon]="statusIconMap.get(status) ?? ''"
    class="body-small"></vc-badge>
